import { jsx as _jsx } from "react/jsx-runtime";
export const MenuTitle = ({ label }) => {
    return (_jsx("div", { "data-eco-component": "menu-title", className: "flex justify-between whitespace-nowrap px-2 pb-1 pt-4 text-sm text-gray-300", children: label }));
};
